<template>
  <q-dialog persistent ref="dialog" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-card-section>
        <div class="text-h6">Vplus Wallet</div>
      </q-card-section>

      <q-card-section>
        <q-form ref="form">
          <!-- <div class="text-subtitle1">Phone number</div> -->
          <!-- <q-input
            dense
            outlined
            :maxlength="10"
            label="Phone number"
            v-model="phone"
            :rules="[(val) => !!val || 'Field is required']"
          /> -->
          <VuePhoneNumberInput
            default-country-code="TH"
            :preferred-countries="['TH', 'US', 'GB']"
            v-model="phoneNumberDummy"
            :error="phoneNumberError"
            @update="onUpdatePhoneNumber"
          />
          <!-- <div class="text-subtitle1">Member ID</div> -->
          <!-- <q-input
                        dense
                        outlined
                        :maxlength="6"
                        label="Member ID"
                        v-model="memberId"
                        mask="XXXXXX"
                        :rules="[(val) => !!val || 'Field is required']"
                    /> -->
        </q-form>
      </q-card-section>

      <q-separator />

      <!-- buttons example -->
      <q-card-actions align="right">
        <q-btn
          :loading="loading"
          unelevated
          no-caps
          color="primary"
          label="Continue"
          @click="onOKClick"
        />
        <q-btn
          unelevated
          no-caps
          color="primary"
          label="Cancel"
          @click="onCancelClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { copyToClipboard } from "quasar";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "PayVplus",
  props: ["store", "orderId", "vphone", "vmemberId"],
  emits: [
    // REQUIRED
    "ok",
    "hide",
  ],
  components: {
    VuePhoneNumberInput,
  },
  data() {
    return {
      loading: false,
      phone: null,
      memberId: null,
      phoneNumberDummy: null,
      phoneNumberError: null,
    };
  },
  computed: {
    // isValidPhone() {
    //     return this.phoneNumber.length == 10;
    // },
    // isValidID() {
    //     if()
    //     return this.memberId.length >= 6;
    // },
  },
  watch: {
    vphone: {
      handler: function (value) {
        this.phone = value;
      },
    },
    vmemberId: {
      handler: function (value) {
        this.memberId = value;
      },
    },
  },
  mounted() {
    console.log("mounted:", this.text);
  },
  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit("hide");
    },

    onUpdatePhoneNumber(val) {
      this.phone = val.formattedNumber;
      this.phoneNumberError = !val.isValid;
    },

    async onOKClick() {
      let success = await this.$refs["form"].validate();

      if (this.phoneNumberError || !this.phone) {
        this.phoneNumberError = true;
        return;
      }

      console.log({ success });
      if (success) {
        this.$emit("ok", {
          phone: this.phone,
          //   memberId: this.memberId,
        });
        this.hide();
      }
      //     try {
      //         this.loading = true;
      //         const payload = {
      //             orderId: this.orderId,
      //             memberId: this.memberId,
      //             mobile: this.phone,
      //         };

      //         const response = await this.$store.dispatch(
      //             "order/payByWallet",
      //             payload
      //         );

      //         console.log({ response });
      //         this.$emit("ok");
      //         this.hide();
      //         this.loading = false;
      //     } catch (error) {
      //         console.warn(error);
      //         this.loading = false;
      //     }
      // }
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      // this.$emit("ok");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      // this.hide();
    },

    onCancelClick() {
      // we just need to hide the dialog
      this.hide();
    },

    onCopy() {
      copyToClipboard(this.url);
    },
  },
};
</script>
